import { render, staticRenderFns } from "./chanliang.vue?vue&type=template&id=06ac8c0e&"
import script from "./chanliang.vue?vue&type=script&lang=js&"
export * from "./chanliang.vue?vue&type=script&lang=js&"
import style0 from "./chanliang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports